import { addYears, getYear } from 'date-fns'
import { customizeError, formatDNI } from '@chilecompra/react-kit'
import { COMPANY_SIZE_BY_INCOME_BRACKET, COMPANY_SIZE_BY_SALES_INCOME } from '../../config/settings/constant'
import { makeActionCreator } from '../../config/store/utils'
import { checkIfForeignDni, isNaturalPerson } from '../../modules/utils/helpers'
import { getIncomeBracket, getSalesIncome, getSellerBusinessSize } from '../../services/sii'

export const GET_FINANCIAL_SUITABILITY = 'GET_FINANCIAL_SUITABILITY'
export const GET_FINANCIAL_SUITABILITY_ERROR = 'GET_FINANCIAL_SUITABILITY_ERROR'
export const GET_FINANCIAL_SUITABILITY_SUCCESS = 'GET_FINANCIAL_SUITABILITY_SUCCESS'
export const onGetFinancialSuitability = makeActionCreator(GET_FINANCIAL_SUITABILITY)
export const onGetFinancialSuitabilityError = makeActionCreator(GET_FINANCIAL_SUITABILITY_ERROR, 'payload')
export const onGetFinancialSuitabilitySuccess = makeActionCreator(GET_FINANCIAL_SUITABILITY_SUCCESS, 'payload')
export const onGetFinancialSuitabilityThunk = payload => async dispatch => {
  dispatch(onGetFinancialSuitability())

  try {
    const isForeign = checkIfForeignDni(payload.dni)
    if (!payload.isPrivated || isForeign) {
      return
    }
    const cleanDni = formatDNI(payload.dni, 2)

    // The endpoint requires a year of consultation, but we don't know which year has information.
    // If for the current year minus one its returns an error, we try with the previous year.
    const initialYear = getYear(addYears(new Date(), -1))
    const maxYear = getYear(addYears(new Date(), -2))

    // Foreign seller are marked as "legal" seller type
    const sellerType = !isForeign && isNaturalPerson(payload.dni) ? 'natural' : 'legal'

    const recursion = async (dni, year, service) => {
      try {
        return await service({ dni, year })
      } catch (error) {
        if (year > maxYear) {
          return recursion(dni, year - 1, service)
        }
        throw error
      }
    }

    const { data } = await recursion(
      cleanDni,
      initialYear,
      sellerType === 'legal' ? getSalesIncome : getIncomeBracket
    ).catch(error => {
      if (error?.originalError?.response?.data?.errores[0]?.codigo.includes('No hay datos para rut')) {
        return {}
      }
      throw error.originalError
    })

    const { data: dataSize } = await getSellerBusinessSize({ dni: payload.dni })

    let orgSizeDetails
    if (sellerType === 'legal') {
      orgSizeDetails = COMPANY_SIZE_BY_SALES_INCOME[data?.payload?.tamano]?.details || ''
    } else {
      orgSizeDetails = COMPANY_SIZE_BY_INCOME_BRACKET[data?.payload?.tramo]?.details || ''
    }

    return dispatch(
      onGetFinancialSuitabilitySuccess({
        dni: payload.dni,
        lastDeclaredPeriod: data?.payload?.anioComercial || maxYear,
        orgSize: data?.payload?.tamano || data?.payload?.tramo,
        orgSizeDetails,
        orgSizeLabel: dataSize?.payload?.tamano || ''
      })
    )
  } catch (error) {
    return dispatch(
      onGetFinancialSuitabilityError({
        dni: payload.dni,
        error: customizeError({
          originalError: error?.originalError,
          code: error?.code,
          reason: 'SOMETHING_WENT_WRONG_ERROR'
        }).toObject()
      })
    )
  }
}
